import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { CfarPostBookingConfirmation } from "./component";
import { IStoreState } from "../../../../reducers/types";
import { cfarPostBookingPurchaseResponseSelector } from "../../reducer/selectors/postBooking";
import { getConfirmationEmail } from "../../../book/reducer/selectors";

const mapStateToProps = (state: IStoreState) => ({
  purchaseResponse: cfarPostBookingPurchaseResponseSelector(state),
  confirmationEmail: getConfirmationEmail(state),
});

const connector = connect(mapStateToProps);

export type CfarPostBookingConfirmationConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedCfarPostBookingConfirmation = withRouter(
  connector(CfarPostBookingConfirmation)
);
